import React, { useState, useEffect } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import styles from './ACClue.module.scss';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

const ACClue = ({ isChecked, onCheckChanged, clueValue, onClueValueChanged, style }) => {
  const [error, setError] = useState(undefined);

  const checkClueValidity = (clueName) => {
    const regex = /^[A-Za-z0-9\s-'+&ÅåÄäÖöÆæØø]+$/;
    const isValid = regex.test(clueName);
    if (!isValid || isEmpty(clueName)) {
      setError(
        `A solution cannot be empty. Capitalisation is excluded from validation. Allowed characters are: A-Z, numbers and symbols ' - + &`
      );
      return false;
    } else {
      setError(undefined);
      return true;
    }
  };

  useEffect(() => {
    checkClueValidity(clueValue);
  }, [clueValue]);
  return (
    <div style={style}>
      <FormControlLabel
        control={<Checkbox color="primary" checked={isChecked} onChange={onCheckChanged} />}
        label={'Solvable'}
        key={'solvable'}
      />
      {isChecked && (
        <>
          <TextField
            value={clueValue}
            onChange={onClueValueChanged}
            className={styles.textField}
            error={!!error}
          />
          {<p className={styles.error}>{error}</p>}
        </>
      )}
    </div>
  );
};

ACClue.propTypes = {
  isChecked: PropTypes.bool,
  onCheckChanged: PropTypes.func.isRequired,
  clueValue: PropTypes.string,
  onClueValueChanged: PropTypes.func.isRequired,
  style: PropTypes.objectOf(PropTypes.string),
};

ACClue.defaultProps = {
  isChecked: false,
  clueValue: '',
  style: {},
};

export default ACClue;
